module.exports = __webpack_public_path__ + "static/media/banner9.26d7393d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner9.png
// module id = 1578
// module chunks = 10